import React from 'react';
import styled from 'styled-components';

import {Flex, mobileMediaQuery, tabletMediaQuery} from '../../styles';

import PlayIcon from '../../assets/play_icon.png';

function LiveBox({
    title,
    subtitle,
    footer,
    link,
    now,
    duration,
    background,
    footerColor,
    action,
    onClick,
    ...props
}) {
    return (
        <Container
            direction="column"
            alignItems="flex-start"
            background="white"
            onClick={onClick}
        >
            <Flex
                margin="16px 0 17px 0"
                width="100%"
                justifyContent="flex-start"
                flex="1"
            >
                <Flex
                    alignItems="flex-start"
                    direction="column"
                    margin="0 auto 0 24px"
                    width="calc(100% - 98px)"
                >
                    <Title>{title}</Title>
                    <SubTitle>{subtitle}</SubTitle>
                </Flex>

                <PlayButton title={subtitle} onClick={action}>
                    <img src={PlayIcon} alt="Play" title={subtitle} />
                </PlayButton>
            </Flex>

            <FooterContainer background={footerColor}>
                <LiveCircle />
                <FooterText>{footer}</FooterText>
            </FooterContainer>
        </Container>
    );
}

const Container = styled(Flex)`
    max-width: 406px;
    width: 100%;
    padding: 0px;
    border-radius: 0px;
    overflow: hidden;
    box-sizing: border-box;

    ${tabletMediaQuery} {
        max-width: 394px;
    }

    ${mobileMediaQuery} {
        width: 100%;
        max-width: 100%;
        justify-self: center;

        height: auto;

        & > ${Flex} > ${Flex} {
            max-width: calc(100% - 105px);
        }
    }
`;

const Title = styled.h1`
    margin: 0;
    color: #211921;
    font-family: 'AvenirNextRoundedStd';
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    text-transform: uppercase;
`;

const SubTitle = styled.h2`
    margin: 0;
    color: #080008;
    font-family: 'TTNormsProExtraBlack';
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    text-transform: uppercase;
    text-overflow: break-word;
`;

const PlayButton = styled.button`
    margin: 0px;
    padding: 0px;
    border: none;
    margin-right: 24px;
    height: 48px;
    width: 48px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: white;

    svg rect {
        fill: #fff;
    }
`;
const FooterContainer = styled(Flex)`
    width: 100%;
    padding: 10px 24px;
    margin: auto 0 0 0;
    box-sizing: border-box;
    background: linear-gradient(
        270deg,
        ${props => props.background} 0%,
        #ccf0ff 100%
    );
`;

const LiveCircle = styled.div`
    height: 8px;
    width: 8px;
    border-radius: 100%;
    background: rgb(237, 0, 128);
    margin-right: 6px;
`;

const FooterText = styled.p`
    margin: auto auto auto 0;
    color: #080008;
    font-family: 'AvenirNextRoundedStd';
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    text-transform: uppercase;
`;

export default LiveBox;
